import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { useEffect } from 'react';
import { Form, Select } from 'antd';
import { SelectOption } from '../../../../../../../types/select-option';
import { LicenseTypeEnum } from '../../../../../enums/license-type.enum';
import { showLoadingAlertMessage } from '../../../../../../../utils/show-loading-alert-message/show-loading-alert-message';
import { networkCall } from '../../../../../../../utils/network-call/network-call';
import { showDefaultErrorMessages } from '../../../../../../../utils/show-default-error-message/show-default-error-messages';
import { AlertMessageState, clearAlertMessage, showAlertMessage } from '../../../../../../../redux/reducer/alert-message.reducer';
import { AlertMessages } from '../../../../../../../enums/alert-messages.enum';
import { CreateLicenseSuccessResponse } from '../../../../../types/api/create-license-success-response';
import { DefaultErrorResponse } from '../../../../../../../types/api/error/default-error-response/default-error-respose.type';
import { ValidationErrorResponseData } from '../../../../../../../types/api/error/validation-error-response-data/validation-error-response-data.type.';
import { tranformAPIValidationErrorToAntDValidationMessage } from '../../../../../../../utils/validation/transform-api-validation-errors-to-antd-validation-messsages';
import { setOpenKeys, setSelectedMenuItemKeys } from '../../../../../../../redux/reducer/antd-layout-info.reducer';
import { CMSButton } from '../../../../../../../components/cms/button/cms-button.';
import { getImageUrl } from '../../../../../../../utils/image-helper/get-image-url';

export const AdminLicenseAdd = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const params = useParams();

    const typeOptions: SelectOption[] = [
        {
            label: 'Headsetes',
            value: LicenseTypeEnum.Headset
        },
        {
            label: 'Tabletes',
            value: LicenseTypeEnum.Tablet
        },
        {
            label: 'Kombinált (Headset + Tablet)',
            value: LicenseTypeEnum.Combined
        }
    ];

    const handleFinish = async (values: any) => {
        showLoadingAlertMessage();
        
        const response = await networkCall(`/companies/${ params.companyId }/licenses`, {
            method: 'POST',
            body: {
                type: values.type
            }
        });

        const messageShowed = showDefaultErrorMessages(response);
        if (messageShowed) return;

        dispatch(clearAlertMessage());
        const alertMessageState: AlertMessageState = {
            alertMessageType: 'error',
            alertMessageText: AlertMessages.UnknownErrorTryAgain
        };

        if (response?.status === 201) {
            const res: AxiosResponse<CreateLicenseSuccessResponse> = response;

            alertMessageState.alertMessageText = 'Mentés sikeres.';
            alertMessageState.alertMessageType = 'success';
            navigate(`/cms/admin/licenses/edit/${ res.data.license.id }`);

        } else if (response?.status === 400) {
            const res: AxiosResponse<DefaultErrorResponse> = response;

            switch (res.data.code) {

                case 1000:
                    const _res: AxiosResponse<DefaultErrorResponse<ValidationErrorResponseData[]>> = response;
                    alertMessageState.alertMessageText = 'Hibásan megadott beviteli mezők.';
                    const validationErrors = tranformAPIValidationErrorToAntDValidationMessage(_res.data.data!);
                    form.setFields(validationErrors);
                    break;

            }

        } else if (response?.status === 404) {
            const res: AxiosResponse<DefaultErrorResponse> = response;

            switch (res.data.code) {
                case 9000:
                    alertMessageState.alertMessageText = 'A megadott cég nem található.';
                    break;
            }

        }

        dispatch(showAlertMessage(alertMessageState));
    }

    useEffect(() => {
        dispatch(setOpenKeys(['admin-companies']));
        dispatch(setSelectedMenuItemKeys(['admin-active-companies']));

        return () => {
            dispatch(setOpenKeys([]));
        };
    }, [dispatch]);

    return (
        <>
            <div className="page-title">Új licenc hozzáadása</div>
            <Form
                form={form}
                onFinish={handleFinish}
                layout='vertical'
            >

                <Form.Item
                    label='Típus'
                    name='type'
                    rules={[{required: true, message: 'Típus megadása kötelező!'}]}
                >
                    <Select
                        placeholder="Válasszon típust!"
                        options={typeOptions}
                        className='box-shadow-4-4-8-0 border-0'
                    />
                </Form.Item>

                <Form.Item>
                    <div className='d-flex justify-content-between'>
                        <Link to={`/cms/admin/companies/edit/${ params.companyId }`}>
                            <CMSButton text='Vissza' type='white' iconSrc={getImageUrl('back-icon.png')} />
                        </Link>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <CMSButton text='Mentés' iconSrc={getImageUrl('Save-icon.png')} htmlType='submit' />
                    </div>
                </Form.Item>
                        
            </Form>

        </>
    );
};